import AGREGAR_CONTRATO_ANTICIPO from '@/graphql/mutations/administracion/contratos/contrato/anticipos/agregarContratoAnticipo.gql';
import CONTRATO_ANTICIPOS from '@/graphql/querys/administracion/contratos/contrato/anticipos.gql';
import ACTUALIZAR_CONTRATO_ANTICIPO from '@/graphql/mutations/administracion/contratos/contrato/anticipos/actualizarContratoAnticipo.gql';
import REMOVER_CONTRATO_ANTICIPO from '@/graphql/mutations/administracion/contratos/contrato/anticipos/removerContratoAnticipo.gql';

export default {
  methods: {
    calcularTotal() {
      const {
        porcentaje,
        importeCostoFinanciamiento,
      } = this.contratoAnticipo;
      const {
        porcentajeIva: porcentajeIvaContrato,
      } = this.contrato;
      if (!porcentaje || porcentaje === 0) return;

      const importe = parseFloat((this.contratoImporte * (porcentaje / 100)));
      const totalImporte = (importe + importeCostoFinanciamiento);
      const porcentajeIVA = Number(porcentajeIvaContrato);
      const importeIVA = parseFloat((totalImporte * (porcentajeIVA / 100)));
      const total = parseFloat((totalImporte + importeIVA));

      this.contratoAnticipo.importeInicioTrabajos = importe;
      // calcular porcentaje
      if (importeCostoFinanciamiento > 0 && importe > 0) {
        this.contratoAnticipo.porcentajeCostoFinanciamiento = (
          importeCostoFinanciamiento / importe
        );
      }
      this.contratoAnticipo.importe = totalImporte;
      this.contratoAnticipo.porcentajeIva = porcentajeIVA;
      this.contratoAnticipo.iva = importeIVA;
      this.contratoAnticipo.total = total;
    },
    // Guardar anticipo del contrato
    async mixAgregarAnticipo() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { contratoAnticipo } = this;
      const idContrato = this.contrato.id;
      contratoAnticipo.idContrato = idContrato;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_ANTICIPO,
          variables: { contratoAnticipo },
          update: (store, { data: { agregarContratoAnticipo } }) => {
            const query = {
              query: CONTRATO_ANTICIPOS,
              variables: { idContrato },
            };
            const { contratoAnticipos } = store.readQuery(query);
            const contratoAnticiposCopia = contratoAnticipos.slice();
            contratoAnticiposCopia.push(agregarContratoAnticipo);
            store.writeQuery({
              ...query,
              data: {
                contratoAnticipos: contratoAnticiposCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarAnticipo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_ANTICIPO,
          variables: {
            id: this.contratoAnticipoEditar.id,
            contratoAnticipo: this.contratoAnticipo,
          },
          update: (store, { data: { actualizarContratoAnticipo } }) => {
            const query = {
              query: CONTRATO_ANTICIPOS,
              variables: {
                idContrato: this.contratoAnticipoEditar.idContrato,
              },
            };
            const data = store.readQuery(query);
            const { contratoAnticipos } = data;
            const index = contratoAnticipos
              .findIndex((contratoAnticipo) => contratoAnticipo.id
              === actualizarContratoAnticipo.id);
            if (index !== -1) {
              contratoAnticipos.splice(index, 1, actualizarContratoAnticipo);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarAnticipo() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_ANTICIPO,
        variables: {
          id: this.contratoAnticipoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_ANTICIPOS,
            variables: {
              idContrato: this.contratoAnticipoEliminar.idContrato,
            },
          };
          const data = store.readQuery(query);
          const { contratoAnticipos } = data;
          const index = contratoAnticipos
            .findIndex((anticipo) => anticipo.id === this.contratoAnticipoEliminar.id);
          if (index !== -1) {
            contratoAnticipos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
